import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../utils/LanguageContext';

const LanguageSwitcher = () => {
  const { currentLanguage, toggleLanguage, isGerman } = useLanguage();

  return (
    <motion.div 
      className="language-switcher"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <button 
        onClick={toggleLanguage}
        className="language-btn"
        aria-label={`Switch to ${isGerman ? 'English' : 'German'}`}
        title={`Switch to ${isGerman ? 'English' : 'German'}`}
      >
        <span className="flag-icon">
          {isGerman ? '🇺🇸' : '🇩🇪'}
        </span>
        <span className="language-code">
          {isGerman ? 'EN' : 'DE'}
        </span>
      </button>
    </motion.div>
  );
};

export default LanguageSwitcher; 